import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { StudioFormat, StudioThemeId } from 'fym-shared/src/music24/studioThemes';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../../../common/views/SMLButton/SMLButton';
import { studioThemeMessages } from './studioThemeMessages';
import { studioMessages } from './studioMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Studio; each part uses its own slice of it */
import styles from './Studio.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface StudioStepsProps {
  /** 2: every asset type (design t2); 3: the details of one asset type. */
  step: 2 | 3;
  /** Kept for old callers; the format step is gone (design t2). */
  format?: StudioFormat;
  themeId?: StudioThemeId;
  onBack: () => void;
}

/** The steps line (designs n1, t2): "1 · Canvas loop ✓ / 2 · Details" and Back. */
const StudioStepsComponent: React.FC<StudioStepsProps> = ({ step, themeId, onBack }) => {
  const intl = useIntl();
  const first =
    themeId === undefined
      ? intl.formatMessage(studioMessages.stepAssetFirst)
      : intl.formatMessage(studioMessages.stepDone, {
          step: 1,
          name: intl.formatMessage(studioThemeMessages[themeId].name),
        });
  const items = [first, intl.formatMessage(studioMessages.stepDetailsSecond)];
  const current = step === 2 ? 1 : 2;

  return (
    <nav className={styles.steps} aria-label={intl.formatMessage(studioMessages.stepsLabel)}>
      <ol className={styles.stepList}>
        {items.map((label, index) => (
          <li
            key={label}
            className={clsx(index + 1 === current && styles.stepOn)}
            aria-current={index + 1 === current ? 'step' : undefined}
          >
            {index > 0 ? `/ ${label}` : label}
          </li>
        ))}
      </ol>
      {step === 3 && (
        <SMLButton outline omitCap size="sm" onClick={onBack}>
          {intl.formatMessage(studioMessages.back)}
        </SMLButton>
      )}
    </nav>
  );
};

export const StudioSteps = TypedMemo(StudioStepsComponent);
